import { createFileRoute, redirect } from '@tanstack/react-router';

import { useAuth } from '@/store/auth.ts';

// Bare /admin → role-aware landing. ADMIN gets the Dashboard (its stats endpoint
// is ADMIN-only); TEACHER lands on Courses (the Dashboard would 403 and bounce
// them to login). Anonymous/STUDENT are already filtered by the /admin guard.
export const Route = createFileRoute('/admin/')({
  beforeLoad: () => {
    const { user } = useAuth.getState();
    throw redirect({ to: user?.role === 'ADMIN' ? '/admin/dashboard' : '/admin/courses' });
  },
});
